module.exports = __webpack_public_path__ + "img/car900.b0e24a65.png";